import React from 'react';
import { Beak1, Beak2, Beak3, Beak4, Beak5, Beak6 } from './parts/beak';
import { Eyebrows1, Eyebrows2 } from './parts/eyebrows';
import { Eyes1, Eyes2, Eyes3, Eyes4, Eyes5, Eyes6 } from './parts/eyes';
import { Eyewear1, Eyewear2 } from './parts/eyewear';
import { Headshape1, Headshape2 } from './parts/head_shape';
import { Top1, Top2, Top3, Top4, Top5 } from './parts/top';
import {
  Hairstyle1,
  Hairstyle2,
  Hairstyle3,
  Hairstyle4,
  Hairstyle5,
  Hairstyle6
} from './parts/hairstyle';

export const PARTS = {
  BACKGROUND: ['#FFE8D8', '#FDE8ED', '#DAD9E8', '#D0EBFC', '#CCF8F8', '#E5F8E7'],
  HEAD_SHAPE: (color) => [<Headshape1 fill={color} />, <Headshape2 fill={color} />],
  EYES: (color) => [
    <Eyes1 fill={color} />,
    <Eyes2 fill={color} />,
    <Eyes3 fill={color} />,
    <Eyes4 fill={color} />,
    <Eyes5 fill={color} />,
    <Eyes6 fill={color} />
  ],
  EYEBROWS: (color) => [<Eyebrows1 fill={color} />, <Eyebrows2 fill={color} />],
  EYEWEAR: () => [null, <Eyewear1 />, <Eyewear2 />],
  TOP: (color) => [
    <Top1 fill={color} />,
    <Top2 fill={color} />,
    <Top3 fill={color} />,
    <Top4 fill={color} />,
    <Top5 fill={color} />
  ],
  HAIRSTYLE: (color) => [
    <Hairstyle1 fill={color} />,
    <Hairstyle2 fill={color} />,
    <Hairstyle3 fill={color} />,
    <Hairstyle4 fill={color} />,
    <Hairstyle5 fill={color} />,
    <Hairstyle6 fill={color} />
  ],
  BEAK: (color) => [
    <Beak1 fill={color} />,
    <Beak2 fill={color} />,
    <Beak3 fill={color} />,
    <Beak4 fill={color} />,
    <Beak5 fill={color} />,
    <Beak6 fill={color} />
  ]
};

export const COLORS = {
  BACKGROUND: ['#FFE8D8', '#FDE8ED', '#DAD9E8', '#D0EBFC', '#CCF8F8', '#E5F8E7'],
  HEAD_SHAPE: ['#FFEEA6', '#FFB05C', '#E0C348', '#C5C75C', '#9ABDF4', '#FFB2D9'],
  EYES: [
    '#4F5A70',
    '#3A2F26',
    '#9B683A',
    '#5D5CC7',
    '#38AECC',
    '#F37748',
    '#C75D5C',
    '#C75CC5',
    '#35722D'
  ],
  EYEBROWS: [
    '#5D5CC7',
    '#47507C',
    '#38AECC',
    '#ADF7B6',
    '#ECC30B',
    '#F37748',
    '#C75D5C',
    '#C75CC5',
    '#EAEAEA'
  ],
  TOP: [
    '#5D5CC7',
    '#47507C',
    '#38AECC',
    '#ADF7B6',
    '#ECC30B',
    '#C75D5C',
    '#C75CC5',
    '#EAEAEA'
  ],
  HAIRSTYLE: [
    '#5D5CC7',
    '#47507C',
    '#38AECC',
    '#ADF7B6',
    '#ECC30B',
    '#F37748',
    '#C75D5C',
    '#C75CC5',
    '#EAEAEA'
  ],
  BEAK: ['#EDCE68', '#F4B789', '#84D1EF', '#6FDB4B', '#4F5A70']
};
